import { Navigate, Route, Routes } from 'react-router-dom';
import {
  ClientsPage,
  OperationDetailPage,
  OperationFormPage,
  OperationsListPage,
} from '@/modules/commercial/pages';
import { commercialPaths } from '@/modules/commercial/paths';

export function CommercialModule() {
  return (
    <Routes>
      <Route index element={<Navigate to={commercialPaths.operations} replace />} />
      <Route path={commercialPaths.clients} element={<ClientsPage />} />
      <Route path={commercialPaths.operations} element={<OperationsListPage />} />
      <Route
        path={commercialPaths.operationNew}
        element={<OperationFormPage />}
      />
      <Route
        path={`${commercialPaths.operationDetail}/editar`}
        element={<OperationFormPage />}
      />
      <Route
        path={commercialPaths.operationDetail}
        element={<OperationDetailPage />}
      />
    </Routes>
  );
}
